"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getLogger = _interopRequireDefault(require("./getLogger"));
var logger = (0, _getLogger["default"])('registerContextPacker', 'warn');

/**
 * Tell EkoAnalytics to pack certain contexts / schemas along with these events.
 *
 * You must include the <EkoAnalytics> component on the page prior to calling `registerContextPacker`.
 *
 * The below documentation was copied from the ekoanalytics source code
 * @export
 * @method module:utils#registerContextPacker
 * @param {Object} options The options for registering the contextPacker:
 * @param {string} options.schema The iglu-compliant schema uri. e.g. 'iglu:com.helloeko/app_interaction/jsonschema/1-0-0'
 * @param {string|RegExp} options.match The string or RegExp that EkoAnalytics will test against to decide whether this context should be attached to an event.
 *                                      e.g. 'app.interaction' or /^app\..*$/
 * @param {function} options.getData The function that will return an object representing the context that should be packed. This function will be invoked with the arguments passed to the eventual `track()` call. *Keep in mind that as per JSONSchema / analytics events convention, the keys of the object that getData returns will probably be all lowercase (and not camelCase).*
 * @example registerContextPacker({
 *     schema: 'iglu:com.helloeko/sparks/jsonschema/1-0-0',
 *     match: /app\.\w+/, // Regex for any string that starts with 'app.'
 *     getData: context => ({ projectId: conntext.projectId, elementid: context.id })
 * });
 */
function registerContextPacker(options) {
  logger.debug('[utils/registerContextPacker]::', options);

  // Since this will be called often from mission-critical app code, I'm making this code super extra careful by wrapping it in try catch
  // Obviously there should never be exceptions thrown from pixelmon, debug, etc etc, but this will just catch them in case we miss something
  try {
    if (!window.EkoAnalytics) {
      logger.error("EkoAnalytics not found on window!\nDid you forget to include the <EkoAnalytics /> component on the page?");
      return;
    }

    // eslint-disable-next-line new-cap
    window.EkoAnalytics('registerContextPacker', options);
  } catch (e) {
    logger.error('[utils/registerContextPacker]:: intercepted error from we-sdk! caught', e);
  }
}
var _default = exports["default"] = registerContextPacker;